import { AfterViewInit, Directive, ElementRef, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core'

declare const google: any

export interface PlaceSelection {
    fullAddress: string
    latitude: number
    longitude: number
}

@Directive({
    selector: '[appAddressAutocomplete]',
})
export class AddressAutocompleteDirective implements AfterViewInit, OnDestroy {
    @Output() placeSelected = new EventEmitter<PlaceSelection>()

    private autocomplete: any = null
    private listener: any = null

    constructor(private el: ElementRef<HTMLInputElement>, private ngZone: NgZone) {}

    ngAfterViewInit(): void {
        this.initAutocomplete()
    }

    ngOnDestroy(): void {
        if (this.listener) {
            google.maps.event.removeListener(this.listener)
        }
        this.autocomplete = null
    }

    private initAutocomplete(): void {
        if (typeof google === 'undefined') return

        this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, {
            types: ['address'],
            componentRestrictions: { country: 'za' },
        })

        this.listener = this.autocomplete.addListener('place_changed', () => {
            this.ngZone.run(() => {
                const place = this.autocomplete.getPlace()
                if (!place?.geometry) return

                this.placeSelected.emit({
                    fullAddress: place.formatted_address || place.name,
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng(),
                })
            })
        })
    }
}
